import React, {useEffect, useState} from 'react';
import CONSTANTS from '../constants';
import FieldDisplay from './FieldDisplay';
import { Route, useRouteMatch, Switch, Redirect, useParams, useLocation } from 'react-router-dom';
import BreadCrumbBar from './Layout/Nav/BreadCrumbBar';
import BubbleRow from './BubbleRow';
import { useAuth0 } from '@auth0/auth0-react';

import '../styles/components/_urlDrivenApp.scss';
import RelatedArticleTeaser from './Layout/RelatedArticleTeaser';
import UrlDrivenTopNav from './Layout/Nav/UrlDrivenTopNav';
import ListSkeletonLoader from './Layout/ListSkeletonLoader';
import vUtils from '../VizUtils';

import utils from '../utils';
import BtnDynamic from './Layout/BtnDynamic';

function UrlDrivenAppDisplay({ tenant, content, navs, className=null, appType, defaultPage, displayFieldName, showRelatedNewsField=null, bubbleFields=[], hasSubItems=false, showTitle=true, showBreadCrumb=true }) {
  const { path, url } = useRouteMatch();
  const location = useLocation();
  const {slug} = useParams();
  const [ levelThreeNav, setLevelThreeNav ] = useState(null);

  const effectiveDefault = defaultPage ?? navs?.[0]?.subNav?.[0]?.urlForField;
  const [ loading, setLoading ] = useState(false)
  const [ activeTab, setActiveTab ] = useState();
  const [ worker, setWorker ] = useState(null);
  
  // note: I moved this to constants in the interest of evolving toward dynamic apps - ultimately, we'll move config to a server so we don't bind ourselves and hate to have a code deploy
  const displayBreadCrumbObj = CONSTANTS.DISPLAY_CRUMB_OBJ;

  const backBtnContent = {
    name: 'Back',
    icon: utils.getIcon('chevron-left', 'svg-12 m-i-start vertical-align'),
  }

  const { getAccessTokenSilently, user } = useAuth0();

  // on mount create a web worker to handle the data processing
  useEffect(() => {
    const oldYeller = new Worker(new URL("../OldYellerWebWorker.js", import.meta.url));

    setWorker(oldYeller);
    
    return () => {
      oldYeller.terminate();
    };
  }, []);




  useEffect(() => {
    navs.forEach((navGroup) => {
      navGroup.subNav.forEach((subItem) => {
        if (subItem.urlForField === effectiveDefault) {
          setActiveTab({title: navGroup.groupingTitle, url: subItem.urlForField, level_three: null})
        }
      })
    })

    //send the navs to the worker to process
    if(worker) {
        utils.getAccessToken(getAccessTokenSilently, user).then((token) => {
          worker.postMessage({
            type: CONSTANTS.WORKER_MESSAGE_TYPES.NAV_DATA,
            navData: utils.cleanUpNavs(navs, content)
          });
        }).catch((err) => {
          console.error('Error getting access token:', err);
        })
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
  },[navs, effectiveDefault])


  const noBubbleContent = vUtils.takeOutFieldsInBubbles(content?.fields, bubbleFields);

  useEffect(()=>{
      setLoading(false)
  },[loading])

  // Sync activeTab with current URL 
    useEffect(() => {
    if (!navs || !location?.pathname) return;

    const currentPath = location.pathname.toLowerCase();
    let matchedTab = null;

    navs.forEach((navGroup) => {
      navGroup.subNav?.forEach((subItem) => {
        // Split the path and compare the last segment
        const pathSegments = currentPath.split('/');
        const lastSegment = pathSegments[pathSegments.length - 1];
        if (lastSegment === subItem.urlForField.toLowerCase()) {
          matchedTab = {
            title: navGroup.groupingTitle,
            url: subItem.urlForField,
            level_three: null,
          };
        }
      });
    });
    // set tab only if different to avoid loops
    if (matchedTab) {
      if (activeTab?.url !== matchedTab.url) setActiveTab(matchedTab);
    } else if (activeTab?.url !== effectiveDefault) {
      setActiveTab({ title: 'Overview', url: effectiveDefault, level_three: null });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, navs]);

  const handleNavSelection = (selection, navURL, title) => {
    setLoading(true)
    setLevelThreeNav(selection);
    setActiveTab({title: title, url: navURL, level_three: selection})
  }

  return (
   
      <>
        {
          showBreadCrumb ?
            displayBreadCrumbObj[appType] ?
              <BreadCrumbBar 
                appName={appType} 
                appAltTitle={vUtils.getAppTitle(tenant, appType)}
                displayFieldName={displayFieldName} 
              />
            : <BtnDynamic 
                linkTo={'/'}
                content={backBtnContent}
                classes={'btn-ghost-sm text-primary-light p-i-start d-inline-flex align-items-center lh-1'}
              />
          : null
        }
        <div className={`app-page-display ${appType}`}>
        {
          showTitle ?
          <>  
            <h1 className='h1 m-b-start-08 m-b-end-08'>
              {vUtils.getAppTitle(tenant, appType) || content.fields.toolName || content.fields.name || ''}
            </h1>
            <UrlDrivenTopNav
              apppath={vUtils.getAppURL(tenant, appType) || url?.slice(1)}
              subItems={hasSubItems}
              fields={noBubbleContent}
              activeTab={activeTab}
              sendNavItemToShow={handleNavSelection}
              tenantSettings={tenant}
              subUrlVal={slug}
              path={path}
              passedNav={Array.isArray(navs) && navs.length > 0 ? { appFields: navs } : null}
            />
          </>
          : null
        }
          <Switch>
            <Route exact path={`${path}/:infoID`}>
                {
                  bubbleFields && bubbleFields.length > 0 ?
                    <BubbleRow itemArray={bubbleFields} objToRender={content} />
                  : null
                }
                {
                  showRelatedNewsField ?
                    <RelatedArticleTeaser
                    tenant={tenant}
                    entity={content} 
                    entityType={''} 
                    header='Related News & Company Intelligence'
                    tagQuery={false}
                    searchTerm={slug}
                    />
                  : null
                }
                {
                  !loading?
                  <FieldDisplay 
                    worker={worker}
                    className={className}
                    fields={noBubbleContent} 
                    fieldsDescr={navs} 
                    infoToShow={effectiveDefault}
                    levelThreeNav={levelThreeNav}
                    loading={loading}
                    tenant={tenant} />
                  : <ListSkeletonLoader preview={false} />
                }
            </Route>
            <Redirect exact from={`${path}/`} to={`${path}/${effectiveDefault}`} />
          </Switch>
        </div>
      </>
  )
}
export default UrlDrivenAppDisplay;